import React from 'react'
import { connect, DispatchProp } from 'react-redux';
import Button from 'Components/Button';
import btn from 'Components/Button/Button.scss'
import DropdownSelect from 'Components/Dropdown/DropdownSelect';
import cn from 'classnames'
import cg from 'Scss/app.scss'
import Input from 'Components/Input';
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter';
import { refreshShoppingLists } from 'Utils/redux/actions';
import ListClient from 'Utils/api/ListClient';
import { SetProductQuantityAction } from './ShoppingListDetail';
import { showMessage } from 'Utils/helpers/modalHelper';
import { filterMyLists } from 'Utils/helpers/shoppingListHelpers';
import gtmClientInstance from 'Utils/gtmClient';

type PropType = {
  productId: string
  quantity: number
}

type ReduxPropType = {
  shoppingLists: Redux.IShoppingListState
  userId: string | null
}

type StateType = {
  selectedListId: string | null
  addNewList: boolean
  newListName: string
}

type OwnProps = PropType & ReduxPropType & DispatchProp

class AddProductToListModal extends React.Component<OwnProps, StateType> {
  state = {
    selectedListId: null,
    addNewList: false,
    newListName: ''
  }

  toggleAddNewListDisplay = () => {
    this.setState({ addNewList: !this.state.addNewList })
  }

  onNewListChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      newListName: e.currentTarget.value
    })
  }

  onAdd = async () => {
    uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, true)
    try {
      let listId = this.state.selectedListId
      if (this.state.addNewList) {
        // Create list first
        const newList = await ListClient.getInstance().createList(this.state.newListName)
        gtmClientInstance.sendEvent("shoppingList", { action: "create" });
        listId = newList.data.listId
      }
      const itemsToSync: SetProductQuantityAction[] = [{ action:"SET_PRODUCT_QUANTITY", listId: listId!, productId: parseInt(this.props.productId), quantity: this.props.quantity, syncStarted: null }]
      await ListClient.getInstance().syncListActions({ actions: itemsToSync })
      uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, false)
      gtmClientInstance.sendEvent("shoppingList", { action: "addProduct" });
      // uiEventEmitter.emit(UIEvents.CLOSE_MODAL)
      showMessage('A terméket hozzáadtuk a bevásárlólistához!')
    } catch (e) {
      uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, false)
      // TODO: Show error
    }
  }

  componentDidMount() {
    uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, true)
    this.props.dispatch(refreshShoppingLists())
  }

  componentDidUpdate (prevProps: OwnProps, prevState: StateType) {
    if (prevProps.shoppingLists.isFetching === true && this.props.shoppingLists.isFetching === false) {
      uiEventEmitter.emit(UIEvents.SET_MODAL_LOADING, false)
    }
  }

  render () {
    if (this.props.userId === null) { return null }
    const isFetching = this.props.shoppingLists.isFetching
    const lists = filterMyLists(this.props.userId, this.props.shoppingLists.lists).map(list => { return { title: list.name, value: list.listId, key: list.listId }})
    const canAdd = (!this.state.addNewList && this.state.selectedListId !== null) || (this.state.addNewList && this.state.newListName.length > 5)
    return (
      <div>
        <h3 className={cn(cg.textCenter)}>{isFetching ? 'Listák betöltése...' : 'Válassz listát!'}</h3>
        <br />
        {!this.state.addNewList && (
        <>
          <DropdownSelect
            name="ShopList"
            placeholder="Válassz listát"
            value={this.state.selectedListId}
            items={lists}
            isNullable={true}
            maxListHeight={140}
            onChange={(_, value) => {
              this.setState({
                selectedListId: value
              })
            }}
          />
        <br />
        </>
        )}


        {this.state.addNewList === true && (
          <>
          <Input name="list" type="text" label="Lista neve" placeholder="Új Lista neve" value={this.state.newListName} hideLabel onChange={this.onNewListChange} />
          <br />
          </>
        )}

        <div className={cn(cg.gridX, cg.gridMarginX)}>
          <div className={cn(cg.cell, cg.medium12, cg.textCenter)}>
            <Button className={cn(btn.link)} label={this.state.addNewList ? 'Meglévő lista választása' : "+ Új lista létrehozása"} onClick={this.toggleAddNewListDisplay} />
          </div>
        </div>
        <br /><br />

        <div className={cn(cg.gridX, cg.gridMarginX)}>
          <div className={cn(cg.cell, cg.medium12, cg.textCenter)}>
            <Button
              style={{margin: '5px'}}
              label="Mégsem"
              className={cn(btn.secondary, btn.hollow)}
              onClick={() => { uiEventEmitter.emit(UIEvents.CLOSE_MODAL) }}
            />

            <Button
              style={{margin: '5px'}}
              label="Hozzáadom"
              disabled={!canAdd}
              className={cn(btn.secondary)}
              onClick={this.onAdd}
            />
          </div>
          <br />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: Redux.IReduxState) => {
  const userId = state.session.loggedIn ? state.session.customerData.id : null
  return {
    shoppingLists: state.shoppingLists,
    userId
  }
}

export default connect(mapStateToProps)(AddProductToListModal)
